import classNames from "classnames";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { onChnageViewTo } from "../../redux/MenuSlice/menuSlice";
import MenuFooter from "./MenuFooter";

export const TrainingMenuList = ({ children }) => {
    return (
        <div className="w-full h-full pt-4  flex flex-col  justify-between  z-20 ">
            <div>{children}</div>
            <MenuFooter />
        </div>
    );
};

const Item = ({ img, imgHover, text, viewId, goTo, proyectSelected }) => {
    let colorText = "";
    if (proyectSelected === "679965563ed6fed031d3b488") {
        colorText = "text-[#FF0000]"
    }

    const dispatch = useDispatch();
    const navigator = useNavigate();
    const [imgSelect, setImgSelect] = useState(img)
    const { actualPage } = useSelector((state) => state.menuView);
    let colorSelected = actualPage === viewId ? "bg-[#3366FF]" : "bg-transparent";
    if (proyectSelected === "679965563ed6fed031d3b488") {
        colorSelected = actualPage === viewId ? "bg-[#FF0000]" : "bg-transparent";
    }
    // const background = classNames({ "bg-3366FF": actualPage === viewId, bar: "bg-transparent" !== viewId });
    return (
        <div
            onClick={() => {
                dispatch(onChnageViewTo(viewId))
                setImgSelect(img)
                navigator(goTo)
            }}


            onMouseLeave={() => setImgSelect(img)}
            className={`w-full h-10 cursor-pointer select-none mb-2 ${colorSelected}  ${actualPage === viewId ? "" : "hover:bg-[#3366FF33]"} `}
        >
            <div className="cursor-pointer flex items-center pl-[28px] w-full h-full">
                <img src={actualPage === viewId ? img : imgHover} alt={`Icon of ${text} menu`} className=" w-[17px] h-[17px] object-contain mr-[12px]" />
                <p className={`${actualPage === viewId ? 'text-white font-bold' : ` font-normal ${colorText} `}  text-base`}>{text}</p>
            </div>
        </div>
    );
};

TrainingMenuList.Item = Item;
